import ApiService from "../../api/api";
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            langList: []
        }
    },
    getters: {
        langList: (state) => {
            return state.langList;
        }
    },
    mutations: {
        setLangList(state, value) {
            state.langList = value;
        }
    },
    actions: {
        index({state, commit, getters}, reload = true) {
            return new Promise((resolve, reject) => {
                ApiService.get('/admin/langs')
                    .then((response) => {
                        commit('setLangList', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    }
};
